import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { DimonaRequest } from './dimona-request.interface';
import { DimonaRequestService } from './DimonaRequest.service';

const service = new DimonaRequestService();

export interface DimonaRequestState {
   dimonaRequestsOverview?: PaginatedResponse<DimonaRequest>;
}

const DimonaRequestStore: Module<DimonaRequestState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_DIMONA_REQUEST_OVERVIEW(state, overview: PaginatedResponse<DimonaRequest>) {
         state.dimonaRequestsOverview = overview;
      },
   },
   actions: {
      async getDimonaRequests(context, query?: LocationQuery) {
         const response = await service.getDimonaRequests(query);
         context.commit('SET_DIMONA_REQUEST_OVERVIEW', response);
         return response;
      },
      async resend(context, dimonaRequestId: number) {
         return await service.resend(dimonaRequestId);
      },
   },
};

export default DimonaRequestStore;
